import React from 'react'

const Filler = () => {
  return (
    <div className='filler common-class'>Filler</div>
  )
}

export default Filler;